import { render, staticRenderFns } from "./saleTarget.vue?vue&type=template&id=63eb4c82&scoped=true&"
import script from "./saleTarget.vue?vue&type=script&lang=js&"
export * from "./saleTarget.vue?vue&type=script&lang=js&"
import style0 from "./saleTarget.vue?vue&type=style&index=0&id=63eb4c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb4c82",
  null
  
)

export default component.exports